
const hostname = document.location.hostname;

const getMixpanelKey = () => {
    if (process.env.NODE_ENV === 'development') {
        return process.env.REACT_APP_MIXPANEL_TOKEN_KEY_AZ;
    }

    if (hostname.includes('azoomee')) {
        return process.env.REACT_APP_MIXPANEL_TOKEN_KEY_AZ;
    }

    if (hostname.includes('dvmkids') || hostname.includes('davinci')) {
        return process.env.REACT_APP_MIXPANEL_TOKEN_KEY_DV;
    }

    return "";
}

export default getMixpanelKey